import { defineStore } from 'pinia'

import type FlashMessage from '../types/FlashMessage'

export const useFlashMessageStore = defineStore({
  id: "flashMessageStore",
  state: () => ({
    messages: [] as FlashMessage[],
  }),
  actions: {
    addMessage(message: FlashMessage) {
      const store = this;
      store.messages.push(message);

      if (message.delay > 0) {
        window.setTimeout(function() {
          store.dismissMessage(message.id);
        }, message.delay);
      }
    },
    dismissMessage(id: number) {
      this.messages = this.messages.filter((item) => {
        return item.id != id
      })
    },
    dismissMessages() {
      this.messages = [];
    },
    dismissErrors() {
      this.messages = this.messages.filter((msg: FlashMessage) => {
        return msg.messageType != "danger";
      })
    },
  }
})
